import React from "react";
import getSymbolFromCurrency from 'currency-symbol-map';
import styles from './../Prices.module.scss';

interface MonthlyPrice {
  name: string;
  currency_code: string;
  price: number;
  duration_metric: string;
}

interface SinglePriceProps {
  names: string[];
  prices: MonthlyPrice[];
}

const SinglePrice: React.FC<SinglePriceProps> = ({ names, prices }) => {
  return (
    <div>
        <div className={styles.container}>
          <span>
            {names[0]}
            &nbsp;
          </span>
          <div>
            {
              prices.find((item) => item.name == names[0]) ? 
              <>
                <p>
                  from {getSymbolFromCurrency(prices[0].currency_code) || prices[0].currency_code}
                  {' '}
                  {prices.find((item) => item.name == names[0])?.price}
                </p>
                <span className={styles.duration}>
                  {`/${prices.find((item) => item.name == names[0])?.duration_metric || 'month'}`}
                </span>
                </>
                : 
                <p className={styles.price_on_request}>
                  Price on request
                </p>
            }
          </div>
        </div>
    </div>
  )
}

export default SinglePrice;